import { PurchaseDetail, PurchaseFormValues } from '../../../types/purchases/BasePurchase';

export function mapDebitNote(purchase: PurchaseDetail): PurchaseFormValues {
  const debit = purchase.debitNoteDetails;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',

    products: debit?.details || [],

    taxableSubtotal: debit?.subtotal || 0,
    calculatedIVA: debit?.ivaTotal || 0,
    total: debit?.totalToAdd || 0,

    // Campos no usados por Nota de Débito
    paymentCondition: null,
    creditDays: 0,
    creditDueDate: '',
    perceivedIVA: null,
    totalToRefund: null,
    withheldIVA: null,
    subtotal: null,
    totalQuantity: null,
    netAmount: null,
    freight: null,
    insurance: null,
    fauca: null,
    otherCosts: null,
    exportIva: null,
    totalCost: null,
  };
}
